import branding from "../data/program-branding.json";

export interface ProgramBranding {
	secondaryColor: string;
	primaryColor: string;
	highlightColor: string;
	logoUrl: string;
	name: string;
}

export const DEFAULT_BRANDING = {
	name: "AXA",
	secondaryColor: "#f0f0f5",
	primaryColor: "#020085",
	highlightColor: "#ff1721",
	logoUrl: "brand-images/Logo_Axa.svg",
};

export const getProgramBranding = (
	programId: string | undefined,
): ProgramBranding => {
	if (!programId) {
		return DEFAULT_BRANDING;
	}
	return (branding as any)[programId] || DEFAULT_BRANDING;
};
